import type * as I from './integration.interface'

export function isFieldMap(o: unknown): o is I.IFieldMap {
  return (
    typeof o === 'object' &&
    'srcField' in o &&
    'destField' in o &&
    'outputOptions' in o
  )
}

export function isFormMap(o: unknown): o is I.IFormMap {
  return (
    typeof o === 'object' &&
    'formName' in o &&
    'fieldMaps' in o &&
    Array.isArray(o.fieldMaps) &&
    o.fieldMaps.every(isFieldMap)
  )
}

export function isIntegration(o: unknown): o is I.IIntegration {
  return (
    typeof o === 'object' &&
    'name' in o &&
    'destination' in o &&
    'formMaps' in o &&
    Array.isArray(o.formMaps) &&
    o.formMaps.every(isFormMap)
  )
}
